module.exports = __webpack_public_path__ + "img/alarm-warning-line.1763ae03.svg";